'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiStarHalf = function TiStarHalf(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.2 7.2c-1.5 3.1-3.7 8-3.7 8s-5.2 0.6-8.7 1c-0.3 0-0.6 0.3-0.6 0.5-0.2 0.3 0 0.6 0.1 0.8 2.7 2.3 6.5 6 6.5 6s-1 5.2-1.8 8.7c0 0.3 0 0.6 0.3 0.8 0.4 0.3 0.7 0.3 1 0.2 3-1.7 7.7-4.4 7.7-4.4v-22.1c-0.3 0-0.7 0.3-0.8 0.5z' })
        )
    );
};

exports.default = TiStarHalf;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/star-half.js
// module id = 3982
// module chunks = 0